import IndexStyle from './style.scss';

/**
 * Created by alex.shmaltsuev on 2016-05-08.
 */
import PropTypes from 'prop-types';

import React from 'react';
import Cx from 'classnames';
import Styled from 'styled-components';
import StyledIconWrapper from '../utils/Styled/blankIconWrapper';

const StyledNoDataWrapper = Styled.div`
    color:${props => props.theme.textColor};   
`;


const NoDataTab = function ({noDataText}) {
	return (
		<StyledNoDataWrapper className={Cx(IndexStyle.requestListItemEmpty, IndexStyle.listItemsWrapper, 'listItemsWrapper')}>
			<StyledIconWrapper>
				<span className={Cx('iconIssue',IndexStyle.blankIcon, 'blankIcon')}></span>
			</StyledIconWrapper>
			{noDataText}
		</StyledNoDataWrapper>
	)
};

NoDataTab.propTypes = {
	noDataText: PropTypes.string.isRequired
};

export default NoDataTab;



// WEBPACK FOOTER //
// ./components/Scoreboard/noDataTab.js